import {
    FETCH_COURIER,
} from '../actions/courier';


export const initialState = {
    isFetching: true,
    data: null
};


export const courier = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_COURIER}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_COURIER}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/courier.js